import type { SnapshotDelta } from './api';

/**
 * Client-side mirror of `apps/api`'s `hasDelta`
 * (`modules/production/domain/diff-snapshot.ts`): drives whether the
 * "hay cambios posteriores al cierre sin registrar" warning shows and
 * whether "Registrar cambios posteriores" is enabled.
 */
export function hasDelta(delta: SnapshotDelta): boolean {
  return delta.added.length > 0 || delta.removed.length > 0 || delta.modified.length > 0;
}
